module.exports = __webpack_public_path__ + "static/media/check-white.9ee58f83.svg";